import React from "react";
import PdfViewer from "../../PdfViewer";

const DiseñoSolucionPropuestaTecnicoComercial = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/04-diseño-de-solucion-y-propuesta-tecnico-comercial.pdf`;
  /*const pdfUrl = "/pdf/04-diseño-de-solucion-y-propuesta-tecnico-comercial.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Diseño de Solucion y Propuesta Técnico-Comercial</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default DiseñoSolucionPropuestaTecnicoComercial;
